const PRODUCT_GROUP_RU_NAMES: Record<string, string> = {
  "001": "Ювелирные изделия",
  "002": "Древесина",
  "003": "Сжиженный нефтяной газ",
  "004": "Дериваты",
};

const PRODUCT_GROUP_KK_NAMES: Record<string, string> = {
  "001": "Зергерлік бұйымдар",
  "002": "Ағаш",
  "003": "Сұйытылған мұнай газы",
  "004": "Киік дериваттары",
};

const KK_NAME_OVERRIDE_BY_CODE: Record<string, string> = {
  "004": "Киік дериваттары",
};

// Казахские буквы, которых нет в русском алфавите
const KK_DOCUMENT_REGEX = /[әғқңөұүһі]/i;

const getDocumentTitlePart = (fileName: string): string => {
  if (!fileName) return "";
  const emDashIndex = fileName.lastIndexOf(" — ");
  if (emDashIndex >= 0) {
    return fileName.slice(0, emDashIndex);
  }
  const hyphenIndex = fileName.lastIndexOf(" - ");
  if (hyphenIndex >= 0) {
    return fileName.slice(0, hyphenIndex);
  }
  return fileName.replace(/\.pdf$/i, "");
};

export const isKazakhDocumentFileName = (fileName: string): boolean =>
  KK_DOCUMENT_REGEX.test(getDocumentTitlePart(fileName));

export const filterDocumentsByLocale = <
  T extends { userFilename?: string; fileName?: string; filename?: string },
>(
  files: T[] | null | undefined,
  locale: string,
): T[] => {
  if (!files?.length) return [];
  return files.filter((file) => {
    const name = file.userFilename ?? file.fileName ?? file.filename ?? "";
    const isKk = isKazakhDocumentFileName(name);
    return locale === "kk" ? isKk : !isKk;
  });
};

/** Заявление vs типовой договор по userFilename (RU/KK). */
export const isApplicationDocumentFileName = (fileName: string): boolean =>
  /заявление|өтініш/i.test(fileName ?? "");

export const pickContractAndApplication = <
  T extends { userFilename?: string; fileName?: string; filename?: string },
>(
  files: T[] | null | undefined,
): { contract?: T; application?: T } => {
  if (!files?.length) return {};
  const application = files.find((file) =>
    isApplicationDocumentFileName(
      file.userFilename ?? file.fileName ?? file.filename ?? "",
    ),
  );
  const contract = files.find((file) => file !== application);
  return { contract, application };
};

export const getProductGroupDisplayName = (
  group: { code?: string; name?: string; nameRu?: string; nameKk?: string },
  locale: string,
): string => {
  const code = group.code ?? "";

  if (locale === "kk") {
    return (
      KK_NAME_OVERRIDE_BY_CODE[code] ||
      PRODUCT_GROUP_KK_NAMES[code] ||
      group.nameKk ||
      group.name ||
      group.nameRu ||
      ""
    );
  }

  return (
    PRODUCT_GROUP_RU_NAMES[code] ||
    group.nameRu ||
    group.name ||
    group.nameKk ||
    ""
  );
};

export const localizeProductGroupFileName = (
  fileName: string,
  groupCode: string,
  locale: string,
): string => {
  if (locale !== "kk" || !fileName) return fileName;

  const ruName = PRODUCT_GROUP_RU_NAMES[groupCode];
  const kkName =
    KK_NAME_OVERRIDE_BY_CODE[groupCode] || PRODUCT_GROUP_KK_NAMES[groupCode];

  let result = fileName;
  if (ruName && kkName) {
    result = result.split(ruName).join(kkName);
  }

  const apiKkName = PRODUCT_GROUP_KK_NAMES[groupCode];
  if (groupCode === "004" && apiKkName && apiKkName !== kkName) {
    result = result.split("Туынды құралдар").join(kkName);
  }

  return result;
};
